import { render } from "./FooterComponents.vue?vue&type=template&id=f3b27ef4"
const script = {}

import exportComponent from "/var/www/dhaffaabdillah/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__